module.exports = __webpack_public_path__ + "static/media/download-icon.554b54f2.svg";